import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, useTheme } from "@mui/material";

export function LiveIcon({logoHeight}) {
    const theme = useTheme(); 

    return (
        <Box
            sx={{
                backgroundColor: 'red',
                width: "1rem",
                height: logoHeight,
                display: "flex",
                alignItems: 'center',
                justifyContent: 'center',
                borderRight: `0.2rem solid ${theme.palette.background.default}`,
                flexShrink: 0, 
            }}
        >
            <FiberManualRecordIcon sx={{ color: 'white', fontSize: 12}} />
        </Box>
    );
}
